import { slices } from "@/constants/sliceNames";
import { serializeQueryParams } from "@/utils/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/axios/defaultAxios";

import { errorMessage, successMessage } from "../../actions/messages.actions";

const endpoint = "/invitation";

/***** List all Invitations ******/
export const requestInvitationsList = createAsyncThunk(
  `${slices.invitations}/requestInvitationsList`,
  async (filters, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${endpoint}?${serializeQueryParams(filters)}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const requestInvitationsListStatus = {
  [requestInvitationsList.fulfilled]: (state, action) => {
    state.items = action.payload.data;
    state.records_count = action.payload.records_count;
    state.loading = false;
  },
  [requestInvitationsList.pending]: (state, action) => {},
  [requestInvitationsList.rejected]: (state, action) => {
    state.error = action.payload.error;
    state.loading = false;
  },
};

/***** Delete invitation by ID *******/
export const requestDeleteInvitation = createAsyncThunk(
  `${slices.invitations}/requestDeleteInvitation`,
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${endpoint}/${id}`);
      dispatch(successMessage(response.data.message));
      return { id };
    } catch (error) {
      dispatch(errorMessage(error.response.data));
      return rejectWithValue(error.response.data);
    }
  }
);

export const requestDeleteInvitationStatus = {
  [requestDeleteInvitation.fulfilled]: (state, action) => {
    state.items = state.items.filter((item) => item._id !== action.payload.id);
    state.loading = false;
  },
  [requestDeleteInvitation.pending]: (state, action) => {
    state.loading = true;
  },
  [requestDeleteInvitation.rejected]: (state, action) => {
    state.error = action.payload.error;
    state.loading = false;
  },
};

/***** Adding new invitation ******/
export const requestSendInvitation = createAsyncThunk(
  `${slices.invitations}/requestSendInvitation`,
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${endpoint}`, data, {
        headers: { organization: data.organization },
      });
      dispatch(successMessage(response.data.message));
      dispatch(requestInvitationsList({ organization: data.organization }));
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error || error.response?.data?.data?.error || error.message));
      return rejectWithValue(error.response.data);
    }
  }
);

export const requestSendInvitationStatus = {
  [requestSendInvitation.fulfilled]: (state, action) => {
    // TODO: Request from Backend to return issuer_info in the response
    // state.items.push(action.payload);
    // state.records_count += 1;
  },
  [requestSendInvitation.pending]: (state, action) => {
    state.loading = true;
  },
  [requestSendInvitation.rejected]: (state, action) => {
    state.error = action.payload.error;
    state.loading = false;
  },
};
